import { render, staticRenderFns } from "./slideBar.vue?vue&type=template&id=f68dbe96&scoped=true"
import script from "./slideBar.vue?vue&type=script&lang=js"
export * from "./slideBar.vue?vue&type=script&lang=js"
import style0 from "./slideBar.vue?vue&type=style&index=0&id=f68dbe96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68dbe96",
  null
  
)

export default component.exports